import { ApiBase } from '@bymason/api-base';
import { GetNotificationsOptions, NotificationModel, NotificationResponse } from './types';

export * from './types';

class Notifications extends ApiBase {
  private static instance: Notifications;

  private constructor() {
    super();
  }

  /**
   * There is no need for consumers to ever call this method as its purely used to enforce a singleton module pattern.
   * @returns An Notifications instance
   */
  public static getInstance(): Notifications {
    if (!Notifications.instance) {
      Notifications.instance = new Notifications();
      Notifications.instance.configure({ apiVersion: 'beta' });
    }

    return Notifications.instance;
  }

  /**
   * Gets all Notifications configured with the account.
   * @param options metadata required to get the notifications.
   * @param clientToken token required for proper authorization.
   * @returns either NotificationsModel[] or void
   */
  public async getNotifications(options: GetNotificationsOptions, clientToken: string) {
    const urlTemplate = this.getEndpointTemplate('notification?metric=:metric');
    const url = this.expandUrlParams(urlTemplate, options);

    const dataResponse = await this.callJsonEndpoint<NotificationResponse>({
      clientToken,
      method: 'GET',
      url,
    });

    return dataResponse;
  }

  /**
   * Deletes an Notification.
   * @param options metadata required to get an Notification.
   * @param clientToken token required for proper authorization.
   * @returns either ScopeModel[] or void
   */
  public async deleteNotification(id: string, clientToken: string) {
    const url = this.getEndpointTemplate(`notification/${id}`);

    const dataResponse = await this.callJsonEndpoint<{ id: string }>({
      clientToken,
      method: 'DELETE',
      url,
    });

    return dataResponse;
  }

  /**
   * Creates a Notification.
   * @param options metadata required to create an Api Keys.
   * @param clientToken token required for proper authorization.
   * @returns either ScopeModel[] or void
   */
  public async createNotification(options: NotificationModel, clientToken: string) {
    const url = this.getEndpointTemplate('notification');

    const dataResponse = (await this.callJsonEndpoint)<NotificationModel>({
      body: JSON.stringify(options),
      clientToken,
      method: 'POST',
      url,
    });

    return dataResponse;
  }
}

export const notificationsClient = Notifications.getInstance();
